import {
  IBoardPresentation,
  IBoardPresentationRoom,
} from '../../../dtos/IBoardSnapshot';

export const NEXT_PRESENTATIONS_LIMIT = 2;

export interface IPresentationRoomView {
  room_id: string;
  room_name: string;
  /** Equipe com a banca agora, pelo horário. */
  current: IBoardPresentation | null;
  /** Segundos que faltam dos 15 min da equipe atual. */
  remaining_seconds: number | null;
  next: IBoardPresentation[];
}

const time = (iso: string) => new Date(iso).getTime();

/**
 * Painel "Apresentação técnica" do telão (FE-60). O snapshot só traz o que
 * ainda não tem nota; o relógio (em hora de parede, como o cronograma) decide
 * quem está na sala e quem vem a seguir. Sala sem nada a mostrar some.
 */
export function presentationRooms(
  rooms: IBoardPresentationRoom[] | undefined,
  nowWall: number,
  limit = NEXT_PRESENTATIONS_LIMIT,
): IPresentationRoomView[] {
  return (rooms ?? [])
    .map(room => {
      const sorted = [...room.presentations].sort(
        (a, b) => time(a.starts_at) - time(b.starts_at),
      );
      const current =
        sorted.find(
          p => time(p.starts_at) <= nowWall && nowWall < time(p.ends_at),
        ) ?? null;

      return {
        room_id: room.room_id,
        room_name: room.room_name,
        current,
        remaining_seconds: current
          ? Math.max(0, Math.ceil((time(current.ends_at) - nowWall) / 1000))
          : null,
        next: sorted.filter(p => time(p.starts_at) > nowWall).slice(0, limit),
      };
    })
    .filter(room => room.current || room.next.length > 0);
}

/** "08:12" a partir de segundos. */
export const formatRemaining = (seconds: number): string =>
  `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(
    seconds % 60,
  ).padStart(2, '0')}`;
